import React from "react";
import { FormGroup, FormControl } from "react-bootstrap";
import { FiSearch } from "react-icons/fi";
import "./ShiftPatternSelector.scss";
import { BiEraser } from "react-icons/bi";
import { useTranslation } from "react-i18next";

const ShiftPatternSelector = ({
	searchValue,
	onSearchChange,
	searchControlId = "searchShift",
	searchPlaceholder,
	searchAriaLabel,
	showTimeTypeFilter = true,
	filterTypeId,
	onFilterTypeChange,
	shiftTypeOptions,
	onBorrarClick,
	hasSelection = false,
	showClearButton = true,
	toolbarTrailing = null,
	hintText,
	borrarButtonText,
	borrarAriaLabel,
	children,
}) => {
	const { t } = useTranslation();

	const hint = hintText || t("shiftPatterns.form.selectorHint");
	const placeholder = searchPlaceholder || t("common.search");
	const aria = searchAriaLabel || t("shiftPatterns.form.searchShiftsAriaLabel");
	const borrarText = borrarButtonText || t("shiftPatterns.form.clearShiftsSelection");
	const borrarAria = borrarAriaLabel || t("shiftPatterns.form.clearShiftsAriaLabel");

	return (
		<div className="sp-shift-selector">
			<p className="sp-shift-selector__hint">{hint}</p>
			<div className="sp-shift-selector__toolbar">
				<FormGroup
					className="sp-shift-selector__search form-group form-search"
					controlId={searchControlId}
				>
					<FormControl
						type="text"
						placeholder={placeholder}
						value={searchValue}
						onChange={onSearchChange}
						aria-label={aria}
					/>
					<FiSearch aria-hidden />
				</FormGroup>
				{showTimeTypeFilter && (
					<FormGroup
						className="sp-shift-selector__filter form-group"
						controlId="filterTypeId"
					>
						<FormControl
							as="select"
							value={filterTypeId}
							onChange={onFilterTypeChange}
							aria-label={t("shiftPatterns.form.filterByTimeType")}
						>
							<option value="">{t("shiftPatterns.form.allTypes")}</option>
							{shiftTypeOptions}
						</FormControl>
					</FormGroup>
				)}
				{showClearButton && hasSelection && (
					<button
						type="button"
						className="btn btn-outline-secondary sp-shift-selector__borrar"
						onClick={onBorrarClick}
						aria-label={borrarAria}
					>
						<BiEraser aria-hidden />
						{borrarText}
					</button>
				)}
				{toolbarTrailing && (
					<div className="sp-shift-selector__trailing">{toolbarTrailing}</div>
				)}
			</div>
			<div className="sp-shift-selector__tags" role="list">
				{children}
			</div>
		</div>
	);
};

export default ShiftPatternSelector;
